// extracted by mini-css-extract-plugin
module.exports = {"card":"SurveyInvitations_card__Q5Fy2","switch":"SurveyInvitations_switch__K81jP","label":"SurveyInvitations_label__w6Zmb","description":"SurveyInvitations_description__dkCpB"};